import React, { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { motivations } from '../data/motivations';
export function Motivations() {
  const [activeIndex, setActiveIndex] = useState(0);
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const active = motivations[activeIndex];
  const focusTab = (index: number) => {
    const next = (index + motivations.length) % motivations.length;
    setActiveIndex(next);
    tabRefs.current[next]?.focus();
  };
  const onKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'ArrowRight') focusTab(activeIndex + 1);else if (e.key === 'ArrowLeft') focusTab(activeIndex - 1);else if (e.key === 'Home') focusTab(0);else if (e.key === 'End') focusTab(motivations.length - 1);else return;
    e.preventDefault();
  };
  return <section aria-labelledby="motivations-title" className="bg-blush px-5 sm:px-8 py-16 sm:py-24" data-id="element-153" data-mp="h1qptkwavgwv">
      <div className="max-w-6xl mx-auto" data-id="element-154" data-mp="m0aalhz5qmnn">
        <h2 id="motivations-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum max-w-2xl" data-id="element-155" data-mp="1r6s84acy8twy">
          Een klein creatief moment, iets bijzonders om te maken.
        </h2>

        <div role="tablist" aria-label="Waarvoor wil je punniken?" className="mt-8 -mx-5 px-5 sm:mx-0 sm:px-0 flex gap-2 overflow-x-auto no-scrollbar" data-id="element-156" data-mp="1h8ci6apnrqp1">
          {motivations.map((m, i) => {
          const selected = i === activeIndex;
          return <button key={m.id} ref={el => {
            tabRefs.current[i] = el;
          }} role="tab" id={`tab-${m.id}`} aria-selected={selected} aria-controls={`panel-${m.id}`} tabIndex={selected ? 0 : -1} onClick={() => setActiveIndex(i)} onKeyDown={onKeyDown} className={`min-h-[44px] shrink-0 whitespace-nowrap rounded-full px-5 py-2.5 text-[15px] font-semibold transition-colors duration-200 ${selected ? 'bg-plum text-cream' : 'bg-cream text-ink hover:bg-white'}`} data-id="element-157" data-mp="24x5ggdtr6amt" data-mpi={i}>
                {m.label}
              </button>;
        })}
        </div>

        <div role="tabpanel" id={`panel-${active.id}`} aria-labelledby={`tab-${active.id}`} className="mt-8 rounded-[2rem] bg-cream overflow-hidden shadow-soft" data-id="element-158" data-mp="lzsdhfikmpt8">
          <AnimatePresence mode="wait" initial={false} data-id="element-159" data-mp="c8xow4hure4m">
            <motion.div key={active.id} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid md:grid-cols-2" data-id="element-160" data-mp="c8e84r3xuvs6">
              <div className="relative aspect-[4/3] md:aspect-auto md:min-h-[480px] bg-blush" data-id="element-161" data-mp="88drcztda8hy">
                <img src={active.image} alt={active.imageAlt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-162" data-mp="3ph0rfoa6h5io" />
              </div>
              <div className="p-7 sm:p-10 lg:p-14 flex flex-col justify-center" data-id="element-163" data-mp="1now6wxv0dahz">
                <h3 className="font-serif text-2xl sm:text-3xl leading-snug font-semibold text-plum" data-id="element-164" data-mp="1sn61p7ctm932">
                  {active.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-ink/80" data-id="element-165" data-mp="3d2vt53rqezkq">{active.description}</p>
                <ul className="mt-7 space-y-3.5" data-id="element-166" data-mp="383smxg00mnb6">
                  {active.benefits.map(b => <li key={b} className="flex items-start gap-3 text-base text-ink" data-id="element-167" data-mp="3mwcjfxsntwjn">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-plum-soft text-plum" data-id="element-168" data-mp="3i39p3ng26j2e">
                        <CheckIcon size={12} strokeWidth={3} aria-hidden="true" data-id="element-169" data-mp="3vxj1ibayjff0" />
                      </span>
                      {b}
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}